/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IUsersService } from '@shared/interfaces/users-service.interface';
import { Observable, Observer, take } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private router: Router = inject(Router);
  private usersService: IUsersService = inject(IUsersService);

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return new Observable<HttpEvent<any>>((observer: Observer<HttpEvent<any>>) => {
      this.usersService.getTokenIfExists().pipe(take(1)).subscribe({
        next: (token: string | null) => {
          AddHeadersRequest(token);

          this.ExecuteRequest(next, request).subscribe({
            next: event => { observer.next(event); },
            error: err => { observer.error(err); },
            complete: () => { observer.complete(); }
          });
        },
        error: () => {
          AddHeadersRequest(null);
          this.ExecuteRequest(next, request).subscribe({
            next: event => { observer.next(event); },
            error: err => { observer.error(err); },
            complete: () => { observer.complete(); }
          });
        }
      });
    });

    function AddHeadersRequest(token: string | null): void {
      const headers: { [key: string]: string } = {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
      };
      if (token) {
        headers['Authorization'] = 'Bearer ' + token;
      }
      request = request.clone({
        setHeaders: headers,
        withCredentials: true
      });
    }
  }

  private ExecuteRequest(next: HttpHandler, request: HttpRequest<any>): Observable<HttpEvent<any>> {
    return new Observable<HttpEvent<any>>((observer: Observer<HttpEvent<any>>) => {
      next.handle(request).subscribe({
        next: event => {
          observer.next(event);
        },
        error: (error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.router.navigate(['/account', 'login']);
          }
          observer.error(error);
        },
        complete: () => {
          observer.complete();
        }
      });
    });
  }
}
